import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

const Affix = ({ icon, text, prefix, suffix, size, action, disabled }) => {
  const getIcon = () => <GetIcon type="regular" size={size} {...icon} />;

  return (
    <S.Wrapper
      prefix={prefix}
      suffix={suffix}
      size={size}
      onClick={action}
      disabled={disabled}
    >
      {icon && getIcon()} {text && text}
    </S.Wrapper>
  );
};

export default Affix;
